export default __webpack_public_path__ + "static/media/close-white.acc196ad.svg";